<div class="esf-form-item">
  <label class="esf-form-item__label" for="email">
    <span i18n='@@general.formLabel.email'>Email</span>
    <app-optional *ngIf="optional"></app-optional>
  </label>
  <div class="esf-form-item__field-wrapper" controlErrorContainer>
    <input type="email" class="esf-form-item__field"
           i18n-placeholder="Form placeholder text@@general.formPlaceholder.email" placeholder="Enter email"
           [formControl]="formControl"
           [id]="id"
           (input)="searchInput.next($event)"
           (keydown)="keyDown($event)">
    <span class="esf-form-item__icon esf-password__icon">
      <svg class="esf-icon" width="32" height="32" style="color: #42ce8a; transition: 0.5s;"
           [ngClass]="{'show': showCheckmark, 'hide': !showCheckmark}">
        <use xlink:href="#esf-icon-check"></use>
      </svg>
    </span>
  </div>
</div>
